// import { Row } from 'ant-design-vue'
import viewsSentOrder from '../components/viewPage.vue'
import store from '../../store'
// import orderConfirmed from '../components/orderConfirmed.vue'
import orderStatus from '../components/orderStatus.vue'
import vue from 'vue'
const that = vue.prototype
export default {
  className: 'Order', // 已发出订单
  title: '已发出订单',
  perPage: 30,

  mixin: {

    fields: [
      {
        // 所属用户
        name: 'userid',
        note: '销售人员',
        width: 80,
        validators: [
          val => (val) ? null : '销售员不可为空'
        ]
      },
      {
        name: 'userCompany',
        note: '销售公司',
        width: 80
      },
      {
        name: 'userid.username',
        note: '经理电话',
        width: 110,
      },
      {
        // 型号
        name: 'finishProductid',
        width: 80,
        validators: [
          val => (val) ? null : '成品型号不可为空'
        ]
      },
      {
        // 麦头
        name: 'markid',
        width: 80,
      },
      {
        // 包装
        name: 'packid',
        width: 80,
      },
      {
        // 托盘
        name: 'palletid',
        width: 80,
      },
      {
        // 状态
        name: 'status',
        width: 100,
        view: {
          component: orderStatus
        }
      },
      {
        // 吨数
        name: 'amount',
        width: 80,
        validators: [
          val => (val) ? null : '吨数不可为空'
        ]
      },
      {
        // 运费
        name: 'shipping',
        width: 80,
      },
      {
        name: 'clientid.name',
        width: 110
      },
      {
        name: 'clientid.phone',
        width: 130
      },
      {
        name: 'clientid.address',
        width: 110
      },
      {
        name: 'clientid.linkman',
        width: 80
      },
      {
        // 下单日期
        name: 'orderDate',

        note: '下单日期'
      },
      {
        // 交付日期
        name: 'shipDate',

      },
      {
        // 发出时间
        name: 'sentAt',

      },

      {
        // 备注
        name: 'remarks',
        width: 80,
      },
      {
        name: 'updatedAt',

      }
    ],
  },
  search: [
    'userid',
    'finishProductid',
    'userCompany',
    'orderDate',
    'updatedAt'
  ],
  action: {
    create: false,
    // edit: store.state.user && ((store.state.user.adminRole === 'sale') || (store.state.user.adminRole === 'admin'))
    //   ? {
    //     type: 'row',
    //     text: '编辑',
    //     component: editSentOrder
    //   } : false,
    edit: false,
    view: store.state.user && store.state.user.authority.sentOrder.view ? {
      type: 'row',
      text: '查看',
      component: viewsSentOrder,
    } : false,
    delete: false,
    post: store.state.user && store.state.user.authority.sentOrder.post ? {
      type: 'row',
      text: '确认收货',
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('提示', '确认此订单收货？')
        let data = {
          status: 'deliveriesTaked'
        }
        let rs = null
        if (Object.keys(record).indexOf('taxRate') !== -1) {
          try {
            if (record.verifyStatus === 'secondVerify') { data.status = 'finish' }
            rs = await vm.$modelAjax.put(modelName, record.objectId, data)
          } catch (e) {
            vm.$notification.error({
              message: '网络错误',
              description: '网络错误'
            })
          }
        } else {
          data.status = 'finish'
          vm.$set(data, 'verifyStatus', 'secondVerify')
          rs = await vm.$modelAjax.put(modelName, record.objectId, data)
        }
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '订单已确认收货'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        }
        if (!(record.isReserve)) {
          that.$tkParse.post('/sendMessage/sendToOwner', { record: record, status: '已收货' })
        }
      }
      // component: orderConfirmed
    } : false,
    // 状态撤回
    cancel: store.state.user && store.state.user.authority.sentOrder.post ? {
      type: 'row',
      text: '撤回',
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('提示', '撤回此订单?')
        let rs = vm.$modelAjax.put(modelName, record.objectId, { status: 'complete' }).catch(e => {
          vm.$notification['error']({
            message: '操作失败',
            description: '网络错误,请重试'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '订单已撤回'
          })
          vm.refresh()
          if (!(record.isReserve)) {
            that.$tkParse.post('/sendMessage/sendToStaff', { record: record, status: '生产完成订单' })
            that.$tkParse.post('/sendMessage/sendToOwner', { record: record, status: '生产完成订单' })
          }
        }
      },
      hidden ({ record }) {
        return record && (record.verifyStatus === 'firstVerify' || record.verifyStatus === 'secondVerify')
      }
    } : false
  },
  hooks: {
    async beforeFetch ({ where }) {
      where.status = 'transit'
      // where.status = {
      //   $in: ['transit']
      // }
      where.isReserve = { $ne: true }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  }
}
